import IconClose from "shared/assets/images/icon-close.svg";
import IconFileError from "shared/assets/images/icon-try-again-report-upload-file-icon.svg";
import IconTryAgain from "shared/assets/images/icon-try-again-report-upload.svg";
import "./UploadReportError.scss";

interface UploadReportErrorProps {
  fileName: string;
  fileCount: number;
  onClose: () => void;
  onRetry: () => void;
}

const UploadReportError = ({
  fileName,
  fileCount,
  onClose,
  onRetry,
}: UploadReportErrorProps) => {
  return (
    <div className="upload-error-overlay">
      <div className="upload-error-modal">
        <button className="close-button" onClick={onClose}>
          <img src={IconClose} alt="Close" />
        </button>

        <div className="file-info">
          <img src={IconFileError} alt="File" className="file-icon" />
          <span className="file-name">{fileName}</span>
        </div>

        <p className="error-message">
          <span className="error-label">Error:</span> There was an error
          uploading the {fileCount > 1 ? "files" : "file"}, please try again.
        </p>

        <button className="try-again-button" onClick={onRetry}>
          Try again
          <img src={IconTryAgain} alt="Upload" />
        </button>
      </div>
    </div>
  );
};

export default UploadReportError;
